// test1731
(1731 && 0);
